import Vue from 'vue';

Vue.component('vuetable_override_pricebook', () =>
    import(/* webpackChunkName: 'override' */ './override-index.vue'),
);

Vue.component('vuetable_override_pricebook_editor', () =>
    import(/* webpackChunkName: 'override' */ './override-editor.vue'),
);

Vue.component('override-ial', () =>
    import(/* webpackChunkName: 'override' */ './override-ial.vue'),
);
